export type { TagCloseButtonProps, TagIconProps, TagProps } from './Tag'
export { Tag, TagCloseButton, TagLeftIcon, TagRightIcon } from './Tag'
